export default __webpack_public_path__ + "static/media/BCA11.73ba6f8c.jpg";